import React from "react";

/** Same checkmark as signup / account consent UI */
export function ConsentCheckmarkSvg() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path
        d="M12.5598 4.24727L5.55977 11.2473C5.51914 11.288 5.47089 11.3202 5.41778 11.3422C5.36467 11.3643 5.30774 11.3756 5.25024 11.3756C5.19275 11.3756 5.13582 11.3643 5.08271 11.3422C5.0296 11.3202 4.98134 11.288 4.94071 11.2473L1.87821 8.18477C1.79612 8.10268 1.75 7.99134 1.75 7.87524C1.75 7.75915 1.79612 7.6478 1.87821 7.56571C1.9603 7.48362 2.07165 7.4375 2.18774 7.4375C2.30384 7.4375 2.41518 7.48362 2.49727 7.56571L5.25024 10.3192L11.9407 3.62821C12.0228 3.54612 12.1341 3.5 12.2502 3.5C12.3663 3.5 12.4777 3.54612 12.5598 3.62821C12.6419 3.7103 12.688 3.82165 12.688 3.93774C12.688 4.05384 12.6419 4.16518 12.5598 4.24727Z"
        fill="#1B062F"
      />
    </svg>
  );
}

/** Hollow green outline when unchecked; filled green + check when checked (signup style). */
export function ConsentCheckboxBox({ checked }: { checked: boolean }) {
  return (
    <div
      className="mt-0.5 flex h-[20px] w-[20px] flex-shrink-0 items-center justify-center pointer-events-none transition-[background-color,box-shadow] duration-200"
      style={
        checked
          ? { backgroundColor: "#32F78D" }
          : { boxShadow: "inset 0 0 0 2px #32F78D" }
      }
      aria-hidden
    >
      {checked ? <ConsentCheckmarkSvg /> : null}
    </div>
  );
}

/** Animated marketing opt-in frame from signup (flash, glitter headline, sparkles). */
export function MarketingConsentFlash({
  children,
  className = "mt-6",
  animate = true,
}: {
  children: React.ReactNode;
  className?: string;
  /** When false, keep layout/copy but drop flash/sparkle/glitter motion. */
  animate?: boolean;
}) {
  return (
    <div
      className={`signup-marketing-flash ${animate ? "" : "signup-marketing-flash--static"} ${className}`.trim()}
    >
      {animate ? (
        <>
          <span className="signup-marketing-sparkle" aria-hidden />
          <span className="signup-marketing-sparkle" aria-hidden />
          <span className="signup-marketing-sparkle" aria-hidden />
          <span className="signup-marketing-sparkle" aria-hidden />
        </>
      ) : null}
      <p className="mb-2 flex items-center gap-1.5 font-anton text-[13px] uppercase leading-tight tracking-wide">
        <span className="signup-marketing-headline">Don&apos;t miss our bonuses and new releases</span>
      </p>
      {children}
    </div>
  );
}
